module.exports = __webpack_public_path__ + "static/img/A61831_3.7ed474f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/reportImage/A61831_3.png
// module id = XY81
// module chunks = 1